import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { http, apiError, TOKEN_KEY } from "@/lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      const { data } = await http.post("/auth/login", { email, password });
      localStorage.setItem(TOKEN_KEY, data.token);
      nav("/admin");
    } catch (e2) {
      setErr(apiError(e2));
    } finally {
      setBusy(false);
    }
  };

  const field = "w-full h-12 px-5 rounded-full bg-white/80 border border-[#D7D4CF] text-sm focus:outline-none focus:border-[#C9A961]";
  return (
    <div className="min-h-screen hero-mesh flex items-center justify-center px-6">
      <form onSubmit={submit} data-testid="admin-login-form" className="w-full max-w-md glass-card rounded-[2rem] p-10">
        <img src="/images/fresio-logo.png" alt="Fresio Herbals" className="h-9 w-auto mb-8" />
        <div className="eyebrow !text-[#A68840] flex items-center gap-2 mb-3"><Lock className="w-3.5 h-3.5" /> Team access</div>
        <h1 className="font-editorial text-4xl text-[#1D3A2F] mb-8">Admin Dashboard</h1>
        <div className="space-y-4">
          <input data-testid="admin-login-email" type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className={field} />
          <input data-testid="admin-login-password" type="password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className={field} />
        </div>
        {err && <p data-testid="admin-login-error" className="text-sm text-red-700 mt-4">{err}</p>}
        <button data-testid="admin-login-submit" disabled={busy} className="btn-gold mt-6 w-full h-12 rounded-full text-[12px] tracking-[0.18em] uppercase font-bold inline-flex items-center justify-center gap-2 disabled:opacity-60">
          {busy && <Loader2 className="w-4 h-4 animate-spin" />} Sign in
        </button>
      </form>
    </div>
  );
}
